export default __webpack_public_path__ + "static/media/pic_12.50f41352.jpg";